import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { TripStateModel } from '@app/modules/core/states/trip-state/trip.model';

const DEBOUNCE_TIME_INPUT = 300;

@UntilDestroy()
@Component({
  selector: 'bkg-trip-info-return-flight',
  templateUrl: './trip-info-return-flight.component.html',
})
export class TripInfoReturnFlightComponent implements OnInit, OnChanges {
  @Output() flightNumber = new EventEmitter<string>();
  @Input() tripData: TripStateModel;

  inputControl = new FormControl(null);

  ngOnChanges(): void {
    if (this.tripData?.flight_number) {
      this.inputControl.patchValue(this.tripData.flight_number);
    }
  }

  ngOnInit(): void {
    this.subscribeToInput();
  }

  private subscribeToInput(): void {
    this.inputControl.valueChanges
      .pipe(
        untilDestroyed(this),
        debounceTime(DEBOUNCE_TIME_INPUT),
        distinctUntilChanged()
      )
      .subscribe((value: string) => this.flightNumber.emit(value || null));
  }
}
